import {
  SUBMIT_FORM,
  INIT_FORM,
  LOAD_PERMISSIONS_STARTED,
  LOAD_PERMISSIONS_COMPLETED,
  LOAD_PERMISSIONS_FAILED,
} from "./types"

export const submitForm = () => ({
  type: SUBMIT_FORM,
})

export const initForm = role => ({
  type: INIT_FORM,
  payload: {
    role,
  },
})

export const loadPermissionsStarted = role => ({
  type: LOAD_PERMISSIONS_STARTED,
  payload: {
    role,
  },
})

export const loadPermissionsCompleted = allPermissions => ({
  type: LOAD_PERMISSIONS_COMPLETED,
  payload: {
    allPermissions,
  },
})

export const loadPermissionsFailed = () => ({
  type: LOAD_PERMISSIONS_FAILED,
})
